import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetEventFeatureFlagsQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventFeatureFlagsQuery = { __typename?: 'Query'; eventByName?: { __typename?: 'Event'; id: string; featureFlags?: Array<string | null> | null } | null };

export const GetEventFeatureFlagsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventFeatureFlags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetEventFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventFeatureFlagsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventFeatureFlagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>(GetEventFeatureFlagsDocument, baseOptions);
}
export function useGetEventFeatureFlagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>(GetEventFeatureFlagsDocument, baseOptions);
}
export type GetEventFeatureFlagsQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsQuery>;
export type GetEventFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetEventFeatureFlagsLazyQuery>;
export type GetEventFeatureFlagsQueryResult = Apollo.QueryResult<GetEventFeatureFlagsQuery, GetEventFeatureFlagsQueryVariables>;
